import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator action to set whether Outlook on Shoreline should display in read only mode.
 */
export const setIsReadOnly = mutatorAction('setIsReadOnly', (isReadOnly: boolean) => {
    getStore().isReadOnly = isReadOnly;
});
